import script from "./home.vue?vue&type=script&lang=ts&setup=true"
export * from "./home.vue?vue&type=script&lang=ts&setup=true"

import "./home.vue?vue&type=style&index=0&id=7a4bc4e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4bc4e6"]])

export default __exports__